import _messageBox from "./../../levels/common.blocks/message-box/message-box.react.js";

var MessageBox = _messageBox.applyDecls();

import "./../../levels/common.blocks/message-box/message-box.css";
import "./../../levels/common.blocks/message-box/_size/message-box_size_l.css";
import "./../../levels/common.blocks/message-box/_size/message-box_size_m.css";
import "./../../levels/common.blocks/message-box/_size/message-box_size_s.css";
import "./../../levels/common.blocks/message-box/_size/message-box_size_xl.css";
import "./../../levels/common.blocks/message-box/_tone/message-box_tone.css";
import "./../../levels/common.blocks/message-box/_tone/message-box_tone_dark.css";
import "./../../levels/common.blocks/message-box/_tone/message-box_tone_default.css";
import "./../../levels/common.blocks/message-box/_tone/message-box_tone_grey.css";
import "./../../levels/common.blocks/message-box/_view/message-box_view_default.css";


export default MessageBox;